"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Panel = _lib.Collapse.Panel;
var ArcAccordion = function ArcAccordion(props) {
  var data = props.data,
    defaultActiveKey = props.defaultActiveKey,
    type = props.type,
    bordered = props.bordered,
    onChange = props.onChange,
    accordion = props.accordion,
    expandIconPosition = props.expandIconPosition,
    className = props.className,
    collapsible = props.collapsible,
    isTransparent = props.isTransparent,
    showArrow = props.showArrow;
  return /*#__PURE__*/_react["default"].createElement(_lib.Collapse, {
    defaultActiveKey: [defaultActiveKey && defaultActiveKey],
    onChange: onChange && onChange,
    accordion: accordion && accordion,
    collapsible: collapsible,
    expandIconPosition: expandIconPosition ? "right" : "left",
    bordered: bordered,
    ghost: isTransparent
  }, data && data.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(Panel, {
      header: item.title,
      key: item.key,
      showArrow: item.hasOwnProperty("showArrow") ? item.showArrow : showArrow,
      className: className && className,
      extra: item.action && item.action
    }, /*#__PURE__*/_react["default"].createElement("p", null, item.hasOwnProperty("component") ? item.component : item.content));
  }));
};
var _default = ArcAccordion;
exports["default"] = _default;